module.exports = __webpack_public_path__ + "static/media/05B.79e5e937.png";